import { RootState } from '../store'

export const selectSelf = (state: RootState) => state
